import { render, staticRenderFns } from "./RequiredClientDialog.vue?vue&type=template&id=78fb1644&"
import script from "./RequiredClientDialog.vue?vue&type=script&lang=ts&"
export * from "./RequiredClientDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports